import { useState } from 'react';
import { useIntl } from 'react-intl';

import { useUpdateEffect } from '@xing-com/crate-entity-pages-common';
import { useErrorContext } from '@xing-com/crate-entity-pages-entity-pages-shared-context-error-context';
import { Dialog } from '@xing-com/dialog';
import { IconTrash } from '@xing-com/icons';

import { useRemoveArticleMutation } from '../../../../hooks/use-remove-article-mutation';
import * as Styled from '../article-card-top.styles';

import type { ArticleControlButton } from './types';

export const ArticleRemoveButton: React.FC<ArticleControlButton> = ({
  article,
  disabled,
  onLoadingChange,
}) => {
  const { formatMessage } = useIntl();
  const { showError } = useErrorContext();

  const [show, setShow] = useState(false);

  const [handleRemoveArticle, { loading }] = useRemoveArticleMutation();

  useUpdateEffect(() => {
    onLoadingChange(loading);
  }, [loading]);

  const handleClick = () => {
    setShow(true);
  };

  const onCancelDialog = () => {
    setShow(false);
  };

  const onConfirmDialog = async () => {
    try {
      await handleRemoveArticle(article);
      setShow(false);
    } catch (error) {
      showError({ message: error.message, error });
      setShow(false);
    }
  };

  return (
    <>
      <Styled.Button
        data-testid={`ARTICLE-REMOVE-BUTTON-${article.id}`}
        icon={IconTrash}
        size="small"
        variant="tertiary"
        disabled={disabled}
        loading={loading}
        onClick={handleClick}
      />
      <Dialog
        headline={formatMessage({
          id: 'EP_ARTICLES_MODULE_DELETE_CONFIRMATION_DIALOG_TITLE',
        })}
        text={formatMessage({
          id: 'EP_ARTICLES_MODULE_DELETE_CONFIRMATION_DIALOG_MESSAGE',
        })}
        cancelLabel={formatMessage({
          id: 'EP_ARTICLES_MODULE_DELETE_CONFIRMATION_DIALOG_DISMISS_BUTTON',
        })}
        confirmLabel={formatMessage({
          id: 'EP_ARTICLES_MODULE_DELETE_CONFIRMATION_DIALOG_CONFIRM_BUTTON',
        })}
        isDestructive={true}
        loading={loading}
        onCancel={onCancelDialog}
        onConfirm={onConfirmDialog}
        show={show}
      />
    </>
  );
};
